export enum Country {
  Australia = "Australia",
  Canada = "Canada",
  Ireland = "Ireland",
  Namibia = "Namibia",
  NewZealand = "New Zealand",
  SouthAfrica = "South Africa",
  UnitedKingdom = "United Kingdom",
  UnitedStates = "United States",
}

export enum ActionNames {
  // Clients
  ViewClients = "View Clients",
  CreateClients = "Create Clients",
  UpdateClients = "Update Clients",
  // Jobs
  ViewJobs = "View Jobs",
  CreateJobs = "Create Jobs",
  UpdateJobs = "Update Jobs",
  AssignTeamJobs = "Assign Team Jobs",
  // Financials
  HideFinancialOverview = "Hide Financial Overview",
  HidePricing = "Hide Pricing",
  // Reports
  ViewReports = "View Reports",
  // Team
  ViewTeam = "View Team",
  CreateTeam = "Create Team",
  UpdateTeam = "Update Team",
  // Settings
  ViewSettings = "View Settings",
  UpdateSettings = "Update Settings",
  // Inventory
  ViewInventory = "View Inventory",
  UpdateInventory = "Update Inventory",
  // Expenses
  ViewExpenses = "View Expenses",
  // Suppliers
  ViewSuppliers = "View Suppliers",
  UpdateSuppliers = "Update Suppliers",
}

export enum PurchaseOrderStatus {
  Draft = "Draft",
  // Built in MountMonitor but not yet placed with the supplier. Becomes
  // Ordered once the user actually places it (or marks it ordered).
  ToOrder = "To Order",
  Ordered = "Ordered",
  PartiallyReceived = "Partially Received",
  Received = "Received",
  Cancelled = "Cancelled",
}

export enum Stages {
  Acquisition = "Acquisition",
  Skinning = "Skinning",
  Fleshing = "Fleshing",
  Cleaning = "Cleaning",
  Salting = "Salting",
  Tanning = "Tanning",
  FormPrep = "Form Prep",
  Mounting = "Mounting",
  Detailing = "Detailing",
  Finishing = "Finishing",
  Return = "Return",
  Completed = "Completed",
}

export enum CalibreStages {
  Acquisition = "Acquisition",
  Skinning = "Skinning",
  Fleshing = "Fleshing",
  Cleaning = "Cleaning",
  Drying = "Drying",
  Salting = "Salting",
  Tanning = "Tanning",
  FormPrep = "Form Prep",
  Mounting = "Mounting",
  Detailing = "Detailing",
  Finishing = "Finishing",
  Return = "Return",
  Completed = "Completed",
}

export enum AvwStages {
  Acquisition = "Acquisition",
  Salting = "Salting",
  Tanning = "Tanning",
  "Form Prep/Mounting" = "Form Prep/Mounting",
  Finished = "Finished",
  "Closed/Picked Up" = "Closed/Picked Up",
}

export enum SoaStages {
  AwaitingInstruction = "Awaiting Instruction",
  AwaitingDeposit = "Awaiting Deposit",
  InProcess = "In Process",
  Collected = "Collected",
  Completed = "Completed",
}

export enum ConroeStages {
  Receiving = "Receiving",
  SkinningFleshing = "Skinning/Fleshing",
  Salting = "Salting",
  InTanning = "In-Tanning",
  OutTanning = "Out-Tanning",
  BoilSlip = "Boil/Slip",
  Mounting = "Mounting",
  Prep = "Prep",
  Paint = "Paint - Complete",
  Finishing = "Finishing - Complete",
  Habitat = "Habitat - Complete",
  Return = "Return",
  Completed = "Completed",
}

export enum Roles {
  owner = "owner",
  manager = "manager",
  staff = "staff",
}

export enum PaymentStatus {
  Unpaid = "Unpaid",
  PaidInFull = "Paid in Full",

  // NoDepositRequired = "No Deposit Required",
  PartiallyPaid = "Partially Paid",
  AwaitingDeposit = "Awaiting Deposit",
  DepositReceived = "Deposit Received",
  FailedPayment = "Failed Payment",
}

export enum PaymentType {
  Deposit = "Deposit",
  Partial = "Partial",
  Full = "Full",
}

export enum AccountingIntegration {
  native = "Native",
  quickbooks = "QuickBooks",
  xero = "Xero",
  myob = "MYOB",
}

export enum PartNames {
  Whole = "Whole",
  Antlers = "Antlers",
  Cape = "Cape",
  Horns = "Horns",
  LeftAntler = "Left Antler",
  LeftHorn = "Left Horn",
  RightAntler = "Right Antler",
  RightHorn = "Right Horn",
  Skull = "Skull",
  "Skull & Antlers" = "Skull & Antlers",
  "Skull & Horns" = "Skull & Horns",
  Tail = "Tail",
}

export enum PartNamesSOA {
  Whole = "Whole",
  Cape = "Cape",
  Horns = "Horns",
  LeftHorn = "Left Horn",
  RightHorn = "Right Horn",
  Skull = "Skull",
  SkullAndHorns = "Skull & Horns",
  Tail = "Tail",
  JawBone = "Jaw Bone",
  FullCape = "Full Cape",
  BackSkin = "Back Skin",
  LifeSizeSkin = "Life Size Skin",
  ShinBones = "Shin Bones",
  Scrotum = "Scrotum",
  Tusks = "Tusks",
  Quills = "Quills",
  Feet = "Feet",
  Feathers = "Feathers",
}

export enum NamedUserUID {
  ADMIN = "VwQ5xMg3R5QNbBkqLPXkbFyLr263",
  ADMIN_QB = "I3Ea9ToYyhauuteCfGOBI6Fmn053",
  DWC = "XeDYGQhi13MZa4Jh39hoCwbUa7W2",
  Mesquite = "ePVU84B0ihTW1LCfZWr6YHAmBNi1",
  SOA = "oaJEJNpP25aSsJvlciWVbsYlZBC2",
  STEHLING_GREEN_BAY = "TXr1owVcOCaOkhJNrWvguY7Xyax1",
  STEHLING_JEFFERSON = "qOxNlCHTnpcalg6fCUD6l6ffCKJ2",
  WOOD = "qZ9Tykr0imaBtKmfoKgVulAsBEy2",
  SKINS_AND_SCALES = "m43e57LEoJgNpGwpgz4k3RHP0dv2",
  TMT = "YUm72FtoRxeb6YDPsv62Xpvcll23",
  FRANKS = "IFSu2ZMyegghm4r5RVpouJ2Wo933",
  ELCAZ = "6XasEYXZ5chCsnpQB67CshMhFAH3",
  _419 = "aIKHvgTUkxQz616tY2Bv9zcCTfD2",
  ARTISTIC_VISIONS = "NWSiDZ7HeeWIbaNbX72yuCDpQSi1",
  WILD_KATS = "sXY0KabeZeOy0jVKaekgoNVH11B2",
  KILLIN_TIME = "zCICxRCeGaXzxYmrXJuqBgkdIN32",
  DOWNUNDER_TAXIDERMY = "EJtO3YAl3bMiHDiuAqtRH4D0qtj2",
  BOBS = "lp1atsn0TnM5jHfPcJObvhYoBXN2",
  CROCKETTS = "IEZPEIi90WUA5uq5Y1SoNoSzAlk1",
  NATURES_EXPRESSIONS = "U37IPIQ8Iaf9gzPV7A6tO2xSyRo2",
  MALAKI = "KVmZ0XKsagMjgmy4XjtbzShdtA52",
  G3 = "0vNkfjXzcVNyaHgQaQiiaPtmtbn2",
  CAHILL = "ZvT6IlX6QSYg5fQtFWR2ZxAn2aw1",
  BAISDEN = "fd7F5uul0yQsTNccsz6rZ4pLYcH2",
  NORTH_LEGACY_TAXIDERMY = "33ZjoIC9qeaTAc2jWrsuUMqovV23",
  FLEMMINGS = "x6Lb9jMrlTe9iXJoz5Arvw8cDd92",
  FALLENFEATHERS = "nxB1G968VzU5QqkqPrH72DLMHn92",
  CANECREEK = "qCuGDVt73QS8N0ShClrrcVDDwZ23",
  WHITE_OAK = "k3oFOlEbxOWOQKLY2Wwu3gn1ACJ2",
  GRIZZLY = "9saZIgbvhGQWLL7nilfET3MNwUC2",
  SAFARI = "wiqOyaV9zQg7pgq3kGSc3ut62Wj1",
  FURANDFEATHERS = "vs3y7ZL3BZXrQ9JkTJYGZ68maRs1",
  FURSANDSPURS = "OfEcyLmZjScZ2NMAa5k2YA6Id982",
  BENNYS_CUSTOM_TAXIDERMY = "B06gdfkGdaaib5QWf9MSfCQz8yR2",
  NAMIBIA = "OXSDB5cVX4eDz5V8KSwAgOq19a22",
  ALLOVER = "MJ2VHddJuGX5W8ioVLucAJ75hq52",
  TRUELEGEND = "3DYw2Tl6NZZMU5QpBWCklakwOW32",
  WONDERWILDLIFE = "djk11JdM6LUgs2SJNGG5K7kqtTu2",
  SHEPARDS = "Tr1I0H3yFVQwey7C6FOKkRu66G23",
  ARTISTICKILLS = "HlVrmk5v9UZVct5Y3y97dnhNato2",
  CRAZYWOMANTAXIDERMY = "nbDsnJH2bFbMcj6cDawfgQwtime2",
  PATTONS = "8VRW9qAP5waGCfn5u1qMSCC3AWz2",
  MYRICK = "Is1d0IoCWxNhJaWWZzp9ea2wg1k1",
  HOOKINB = "oeGuH9xknlVTJAkI9lrEuZKgXKn1",
  SAFARISTUDIO = "czdUQ6n5pIXtTB6SpfNLYHjvw803",
  ZIGGYS = "PtfgSQhyD3Vbe1EtUwkOoSv39LL2",
  TRUELIFE = "oemYeBaSASNSsI7tl8oFwadgRFt1",
  ZARATES = "skJ73XCArzYeU0grPH13FGpQP7I2",
  TOPPIN = "m5Gz2nyTyPal1u069OzMfL757S22",
  TEAM_EXTREME = "D7ZdEVSRZ5ROHn34CLRjqzILBiW2",
  BONEZ = "MF8OQh7EZoVd1Hv9sL94F3nvcHi2",
  COLOSSAL = "SFVyXIoybvWmFsuI1Jyl6enMbmC2",
  SKINNERS = "27LgTHtwc5dxQ2FL69oal11cgqR2",
  PEAK_TAXIDERMY = "X2zvpCmWofgMRrYQpWSlkgoqu002",
  BRAZOS_BEND = "WJMkjvX4YiTPzTZLHv1S9MUAjTI3",
  CL_WILDLIFE_DESIGN = "OwhLezOdSfdETkXwoOtQNZ5R9OC3",
  CUSTOM_WILDLIFE = "zk7IGuJ7saXkFmQe8i6Pm1pw4n32",
  CRITTERS = "UtQIOrUtypOfXWboaygLnPzkLtg2",
  HILL_COUNTRY = "7EVCKpAGLAQ4n5aDiR3qJuz6dW62",
  WHITEBONE = "tXcTLvo3jLYCKg47teAckcDlPXC2",
  HER_WILD_ADVENTURES = "DAYVUgCUkeVr9RRuVARSPvWFwmC3",
  WALLHANGER = "mClRa0tzxLhfVYbfNETJKY4MFnh2",
  TAXIDERMY_DESIGNS = "IQjNyT8xsaSOpVjLN3FIld7sjli2",
  YARDBIRDS = "h3qans8vV3gHz0ALKi2edZwEial2",
  DB_TAXIDERMY = "AtQfULwyH8cY2GXzPc6cG9XuGV23",
  _2178_OUTDOORS = "UrGIg6KowaQZiayTAJgER0dWbZr2",
  BUDDY_MENARD = "WItyrHj31WQ8q5ZYdBD37cuIJxY2",
}
